/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { ApiDemoService } from './services/api-demo/api-demo.service';
import { ApiResParserService } from './services/api-res-parser/api-res-parser.service';
import { environment } from '@environments/environment';
import { ApiMockService } from './services/api-mock/api-mock.service';
import { ApiService } from './services/api/api.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';

export const apiServiceFactory = (
  http: HttpClient,
  parser: ApiResParserService
): ApiService => {
  if (environment.devMode && !!localStorage.getItem('useDemo')) {
    return new ApiDemoService(http, parser);
  } else if (environment.devMode && !!localStorage.getItem('useMock')) {
    return new ApiMockService(http, parser);
  } else {
    return new ApiService(http, parser);
  }
};

@NgModule({
  declarations: [],
  imports: [CommonModule, HttpClientModule],
  providers: [
    {
      provide: ApiService,
      useFactory: apiServiceFactory,
      deps: [HttpClient, ApiResParserService]
    }
  ]
})
export class ApiModule {}
